export const ONLINE = 'ONLINE'
export const MOTO_IN_PERSON = 'MOTO_IN_PERSON';
export const MOTO_OTHER = 'MOTO_OTHER';

